import { Alert, FormControl, Grid, InputAdornment, TextField } from '@mui/material'
import React, { useEffect } from 'react'

import {
    CustomAutocomplete,
    LinearLoading
} from '../../../../../common'

const OPPOSITE_VALUES = {
    DOLAR: 'QUETZAL',
    QUETZAL: 'DOLAR'
}
export const BuyingSellingDollars = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputNumberChange, onSelectSearchChange } = FormScreen

    const { fetchAllCashierByCurrencyType } = FetchData
    const { dataCashierByCurrencyType, loadingFetchCashierByCurrencyType } = fetchAllCashierByCurrencyType

    const {
        handleClickCurrencyConverter
    } = Actions


    useEffect(() => {
        fetchAllCashierByCurrencyType.setParamsToSearch({
            idcategoria: formState.idcategoria, // 1: CAJA ADMINISTRATIVA, 2: CAJA CENTRAL
            currency_type: OPPOSITE_VALUES[formState.currency_type] // Según el tipo de moneda seleccionado (solo puede transferir a los mismos tipos)
        })
        fetchAllCashierByCurrencyType.executeFetch()
    }, [formState.currency_type])
    
    useEffect(() => {
        handleClickCurrencyConverter()

    }, [formState.monto_solicitado, formState.tipo_cambio])

    return (
        <>
            {(formState.currency_type === 'DOLAR')&&(
                <Alert severity="info" sx={{ mb: 2 }}>
                    VENTA DE DÓLARES: ingrese el monto en dólares que desea vender.
                    El monto a recibir se calculará en quetzales.
                </Alert>
            )}
            {(formState.currency_type === 'QUETZAL')&&(
                <Alert severity="success" sx={{ mb: 2 }}>
                    COMPRA DE DÓLARES: ingrese el monto en dólares que desea comprar.
                    El monto a desembolsar se calculará en quetzales.
                </Alert>
            )}
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="monto_solicitado">
                            * {formState.currency_type === 'DOLAR'
                                ? 'Monto a Vender'
                                : 'Monto a Comprar'}
                        </label>
                        <TextField
                            id='monto_solicitado'
                            name='monto_solicitado'
                            value={ formState.monto_solicitado_mask } 
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='500.50, 100.00'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode,
                                startAdornment: (
                                    <InputAdornment position="start">US$</InputAdornment>
                                )
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="idcaja_destino">* Caja Destino</label>
                        {(loadingFetchCashierByCurrencyType)&&(<LinearLoading/>)}
                        <CustomAutocomplete 
                            customId="idcaja_destino"
                            customName="idcaja_destino"
                            customValue={formState.idcaja_destino}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcaja_destino', value: value.value }})}
                            customPlaceholder='Seleccionar opción'
                            customOptions={
                                dataCashierByCurrencyType.map(({ idcaja, descripcion_corta, currency_type }) => ({
                                    value: idcaja,
                                    name: `${descripcion_corta} - ${currency_type}`
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={readOnlyMode}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="tipo_cambio"> * Tipo Cambio</label>
                        <TextField
                            id='tipo_cambio'
                            name='tipo_cambio'
                            value={ formState.tipo_cambio_mask } 
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='7.8'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="monto_convertido">
                            * {formState.currency_type === 'DOLAR'
                                ? 'Monto a Recibir'
                                : 'Monto a Desembolsar'}
                        </label>
                        <TextField
                            id='monto_convertido'
                            name='monto_convertido'
                            value={ formState.monto_convertido_mask } 
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='500.50, 100.00'
                            type='text'
                            variant={'filled'}
                            hiddenLabel
                            InputProps={{
                                readOnly: true,
                                startAdornment: (
                                    <InputAdornment position="start">GTQ</InputAdornment>
                                )
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
